<template>
  <div class="card has-padding-20 has-padding-left-0">
    <div class="has-margin-bottom-40 has-margin-top-10 has-border-bottom">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >Application Summary</h2>
    </div>
    <!-- Steps Content -->

    <application-summary-view :shippingRequest="summary" removeStatusInfo></application-summary-view>

    <div class="steps-actions has-margin-top-30">
      <div class="steps-action">
        <a href="#" class="button is-danger" @click="previous">Previous</a>
      </div>
      <div class="steps-action">
        <button class="button is-primary" @click="next">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationSummaryView from "../viewShippingRequestDetails/Main";
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapGetters } = createNamespacedHelpers("shippers");
import { mapGetters as mapRootGetters } from "vuex";

export default {
  name: "ApplicationSummary",

  components: {
    ApplicationSummaryView
  },

  props: {
    moveToNext: { type: Function, required: true },
    moveToPrevious: { type: Function, required: true }
  },

  computed: {
    ...mapGetters({
      shipperConsigneeDetails: "getShipperAndConsigneeDetails",
      dangerousGoods: "getDangerousGoods",
      additionalInfoAndDocs: "getAdditionalInfoAndDocs",
      certificateDocuments: "getCertificateDocuments",
      uploadedDocuments: "getUploadedDocuments",
      referenceNumber: "getFormReferenceNumber"
    }),
    ...mapRootGetters({
      ports: "getPorts"
    }),
    summary() {
      return {
        ...this.shipperConsigneeDetails,
        ...this.additionalInfoAndDocs,
        ...this.certificateDocuments,
        'uploaded_documents':this.uploadedDocuments,
        'dangerousGoods': this.dangerousGoods,
        'reference_number': this.referenceNumber
      };
    }
  },

  methods: {
    previous() {
      this.moveToPrevious();
    },

    next() {
      this.moveToNext();
    }
  }
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.d-none {
  display: none !important;
}
</style>
